import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import { Component, ChangeDetectionStrategy, effect, OnInit, inject, DestroyRef, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { CustomerJourneyViewComponent } from '../customer-journey-view/customer-journey-view.component';
import { RelationshipService } from 'src/app/shared/services/relationship/relationship.service';
import { LtmsLoaderComponent } from 'src/app/shared/components/ltms-loader/ltms-loader.component';
import * as moment from 'moment';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import { ScoreDropdownMenuComponent } from 'src/app/shared/components/score/score-dropdown-menu/score-dropdown-menu.component';
import { LitmusChartBetaComponent } from 'src/app/shared/components/litmus-chart-beta/litmus-chart-beta/litmus-chart-beta.component';
/**
 * HighlightsComponent displays a dashboard of repeat customer metrics, charts, and tables.
 * All data is currently dummy data for UI demonstration purposes.
 */
@Component({
  selector: 'app-highlights',
  standalone: true,
  templateUrl: './highlights.component.html',
  styleUrls: ['./highlights.component.scss'],
  imports: [NgFor, NgIf, NgClass, NgStyle, ScoreDropdownMenuComponent, CustomerJourneyViewComponent, LtmsLoaderComponent, LitmusChartBetaComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HighlightsComponent implements OnInit {
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  /** Dummy data for the detailed customers table */
  customers: any = [];

  /** Dummy data for the project-wise table */
  projects: any = [];

  /** Dummy data for the bar chart (percentages) */
  readonly barData: ReadonlyArray<{
    promoters: number;
    passives: number;
    detractors: number;
  }> = [
      { promoters: 60, passives: 20, detractors: 20 },
      { promoters: 40, passives: 30, detractors: 30 },
      { promoters: 70, passives: 10, detractors: 20 },
      { promoters: 50, passives: 20, detractors: 30 },
      { promoters: 80, passives: 10, detractors: 10 },
      { promoters: 20, passives: 20, detractors: 60 },
      { promoters: 60, passives: 20, detractors: 20 }
    ];


  /** data for the bar chart */
  barChartType: string = 'percent';
  barChart: any = {};

  barChartConfig: any = {
    chartType: 'bar',
    yText: 'Responses',
    minRotation: 0,
    maxRotation: 0,
    stacked: true,
    useCustomConfig: false,
    showPercentage: true,
    stepSize: 20,
    totalValueLabel: 'Total Responses',
    showTotalValue: true,
    minBarWidth: 120,
    data: {
      labels: [],
      datasets: []
    }
  }

  lineChartConfig: any = {
    chartType: 'line',
    yText: 'Rating',
    minRotation: 0,
    maxRotation: 0,
    stacked: false,
    useCustomConfig: true,
    minBarWidth: 20,
    stepSize: 20,
    min: -100,
    max: 100,
    data: {
      labels: [],
      datasets: []
    }
  }

  /** data for the line chart */
  lineChartData: any = {};
  lineChartPlugins = {
    lineColor: '#3777FF',
    gradientStartColor: '#fff',
    gradientEndColor: '#fff',
    borderWidth: 0,
    pointBorderWidth: 5,
    shadowColor: 'rgba(0, 4, 0, 0.6)',
    pointRadius: function (context) {
      // Check if there is only one data point
      const dataLength = context.chart.data.datasets[0].data.length;
      return dataLength === 1 ? 5 : 0; // Show dot with radius 5 if only one data point, otherwise no dot
    },

    pointBorderColor: '#ffffff',
    min: -100,
    max: 100,
    stepSize: 20,
    useCustomMinMax: true,
    color: '#3777FF',
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          min: -100, // Use the input value here
          max: 100, // Set the maximum value of Y-axis
          ticks: {
            stepSize: 1, // Ensure the grid ticks are spaced by 1 unit
            callback: function (value: any) {
              return value; // Display the value as it is
            },
          },
        },
        x: {
          ticks: {
            color: '#000000', // Use the input value for font color
            font: {
              size: 13,
              family: 'Asap'
            }
          }
        }
      },
    },
  }



  overallSummary: any = {
    npsType: 'unavailable'
  };

  selectedCustomer: any = null;

  accountId: any = null;
  unique_field_id: any = null;
  unique_field_type: any = null;
  destroyRef = inject(DestroyRef)

  brandDetailsMap: any = {};

  isOverallSummaryLoading: boolean = true;
  isJourneySummaryLoading: boolean = true;
  isRatingDistributionLoading: boolean = true;
  isUserSummaryLoading: boolean = true;
  isProjectSummaryLoading: boolean = true;


  accountDetails: any = {}
  journeyConfig: any = {};

  barChartDropdown: any = {
    config: {
      // width: '300px',
      isDisabled: false,
      tab: 'journeyViewtype'
    },
    selectedOption: 'All',
    options: [
      { name: 'All', field_id: 'all' },
    ]
  };

  selectedBarChartjourney: any = null;
  lineChartDropdown: any = {
    config: {
      // width: '300px',
      isDisabled: false,
      tab: 'journeyViewtype'
    },
    selectedOption: '',
    options: []
  };
  selectedLineChartjourney: any = null;
  journeyFieldId: any = null;

  constructor(private _relationshipService: RelationshipService, private _stateService: AppStateService, private cdr: ChangeDetectorRef) {
    effect(() => {
      this.isOverallSummaryLoading = true;
      this.isJourneySummaryLoading = true;
      this.isRatingDistributionLoading = true;
      this.isUserSummaryLoading = true;
      this.isProjectSummaryLoading = true;
      if (this._stateService.initialized()) {
        let accountDetails: any = this._stateService.accountDetails();
        this.unique_field_id = this._relationshipService.unique_field_id;
        this.unique_field_type = this._relationshipService.unique_field_type;
        let brandListDetails: any = this._stateService.brandListDetails();
        if (_.isEmpty(brandListDetails) && !_.isEmpty(Helpers?.brandListDetail)) {
          brandListDetails = Helpers.brandListDetail;
        }
        if (brandListDetails && !_.isEmpty(brandListDetails)) {
          this.getBrandDetailsMap(brandListDetails);
        }
        if (accountDetails && accountDetails._id) {
          this.accountDetails = Helpers.deepClone(accountDetails)
          this.accountId = accountDetails._id;
          this.isJourneySummaryLoading = true;

          this.initComponent();
        }
      }

    })

    effect(() => {
      this.isOverallSummaryLoading = true;
      this.isJourneySummaryLoading = true;
      this.isUserSummaryLoading = true;
      this.isProjectSummaryLoading = true;
      this.isRatingDistributionLoading = true;
      let journeyConfig: any = this._relationshipService.journeyConfig();
      if (journeyConfig && !_.isEmpty(journeyConfig)) {
        this.journeyConfig = Helpers.deepClone(journeyConfig)
        this.initComponent();
      }
    })
  }

  ngOnInit(): void {
    // this.isJourneySummaryLoading = true;
    // this.getJourneyList();
  }

  initComponent() {
    if (this.checkReqiredConfiguration()) {
      this.getOverallSummary()
    }
  }

  checkReqiredConfiguration() {
    return (this.journeyConfig && !_.isEmpty(this.journeyConfig) && this.accountDetails && !_.isEmpty(this.accountDetails))
  }

  getBrandDetailsMap(brandListDetails) {
    if (brandListDetails && !_.isEmpty(brandListDetails)) {
      _.each(brandListDetails, (brand: any) => {
        this.brandDetailsMap[brand._id] = brand;
      });
    }
  }

  getOverallSummary() {
    let params: any = this.getQueryParams();
    this._relationshipService.getRelationshipOverallSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
      if (_.get(res, 'data.code') == 0 && _.get(res, 'data.summary') && !_.isEmpty(res?.data?.summary)) {
        if (_.get(res, 'data.config.configs') && !_.isEmpty(res?.data?.config?.configs)) {
          _.each(res.data.config.configs, (config: any) => {
            if (config.name) {
              const key = config.id || config.name;
              if (!this.journeyFieldId) {
                if (config.id) {
                  this.journeyFieldId = 'journey_id';
                } else {
                  this.journeyFieldId = 'journey_name';
                }
              }
              this.selectedJourneyIds.push(key);
              const obj = {
                name: config.name,
                text: config.name,
                field_id: key,
              }
              this.lineChartDropdown.options.push(obj)
              this.barChartDropdown.options.push(obj)
            }
          });

          this.selectedLineChartjourney = this.lineChartDropdown.options[0].field_id;
          this.selectedBarChartjourney = "All";
          this.lineChartDropdown.selectedOption = this.lineChartDropdown.options[0].name;
        }
        const nps = this.getNPS(res.data.summary.total_responses, res.data.summary.promoter, res.data.summary.detractor);
        let npsType = 'unavailable'
        if (nps == 'NA') {
          npsType = 'unavailable'
        } else {
          const npsInt = parseInt(nps)
          if (npsInt < 0) {
            npsType = 'negative'
          } else if (npsInt > 0 && npsInt <= 30) {
            npsType = 'neutral'
          } else if (npsInt > 30) {
            npsType = 'positive'
          }
        }

        this.overallSummary = {
          ...res.data.summary,
          repeated_user_nps: nps,
          npsType: npsType
        };
        this.isOverallSummaryLoading = false;
        this.cdr.detectChanges();
        this.getJourneySummary();
        this.getJourneyTrendSummary(this.selectedLineChartjourney);
        this.getDetailedSummary('project');
        this.getDetailedSummary('user');
      } else {
        this.barChart.labels = [];
        this.lineChartData.labels = [];
        this.isOverallSummaryLoading = false;
        this.isJourneySummaryLoading = false;
        this.isUserSummaryLoading = false;
        this.isProjectSummaryLoading = false;
        this.isRatingDistributionLoading = false;
        this.cdr.detectChanges();
      }
    }, (error: any) => {
      this.barChart.labels = [];
      this.lineChartData.labels = [];
      this.isOverallSummaryLoading = false;
      this.isJourneySummaryLoading = false;
      this.isUserSummaryLoading = false;
      this.isProjectSummaryLoading = false;
      this.isRatingDistributionLoading = false;
      this.cdr.detectChanges();
    })
  }


  getJourneySummary() {
    this.isJourneySummaryLoading = true;
    this.isRatingDistributionLoading = true;
    let params: any = this.getQueryParams();
    this._relationshipService.getRelationshipJourneySummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
      if (_.get(res, 'data.code') == 0 && _.get(res, 'data.summary') && !_.isEmpty(res?.data?.summary)) {
        this.prepareChartData(res?.data?.config, res?.data?.summary);
      } else {
        this.barChart.labels = [];
      }
      this.isRatingDistributionLoading = false;
      this.cdr.detectChanges();

    }, (error) => {
      this.barChart.labels = [];
      this.isRatingDistributionLoading = false;
      this.cdr.detectChanges();
    })
  }

  barChartDataStorage: any = [];

  prepareChartData(journeyConfig: any, data: any) {
    let labels: any[] = [];
    let promoters: any[] = [];
    let passives: any[] = [];
    let detractors: any[] = [];
    let nps: any[] = [];
    this.barChartDataStorage = Helpers.deepClone(data);
    let mapData: any = {};
    _.each(data, (value: any) => {
      const key = value.journey_id || value.journey_name;
      mapData[key] = value;
    });
    _.each(journeyConfig.configs, (config: any) => {
      const key = config.id || config.name;
      if (this.selectedJourneyIds.includes(key) || this.selectedBarChartjourney == "All") {
        let value = mapData[key];
        if (value && value?.total_responses > 0) {
          labels.push(config.name);
          promoters.push(this.computeValue(value.promoter, value.total_responses, this.barChartType == 'percent'));
          passives.push(this.computeValue(value.passive, value.total_responses, this.barChartType == 'percent'));
          detractors.push(this.computeValue(value.detractor, value.total_responses, this.barChartType == 'percent'));
          nps.push(this.getNPS(value.total_responses, value.promoter, value.detractor));
        }
      }
    });

    this.updateBarChartData(labels, promoters, passives, detractors);
    this.isRatingDistributionLoading = false;
    this.cdr.detectChanges();
  }

  updateBarChartData(labels: any[], promoters: any[], passives: any[], detractors: any[]) {
    this.barChartConfig.showPercentage = this.barChartType == 'percent';
    this.barChartConfig.data = {
      labels: labels,
      datasets: [
        {
          label: 'Promoters',
          data: promoters,
          backgroundColor: '#0B7139',
          stack: 'Stack 0',
        },
        {
          label: 'Passives',
          data: passives,
          backgroundColor: '#FAB416',
          stack: 'Stack 0',
        },
        {
          label: 'Detractors',
          data: detractors,
          backgroundColor: '#EC2524',
          stack: 'Stack 0',
        }
      ],
      xText: 'Journey',
      yText: 'Responses',
    };
    this.cdr.detectChanges();
  }

  private computeValue(value: number, total: number, percentage: boolean): number | string {
    if (!percentage) return value || 0;
    return total > 0 ? ((value / total) * 100).toFixed(1) : '0';
  }




  getJourneyTrendSummary(selectedJourney: string) {
    this.isJourneySummaryLoading = true;
    let params: any = this.getQueryParams();
    params[this.journeyFieldId] = selectedJourney;
    this._relationshipService.getRelationshipTrendSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
      if (_.get(res, 'data.code') == 0 && _.get(res, 'data.summary') && !_.isEmpty(res?.data?.summary)) {
        this.prepareTrendSummary(res?.data?.summary, true);
      } else {
        this.lineChartData.labels = [];
      }
      this.isJourneySummaryLoading = false;
      this.cdr.detectChanges();

    }, (error) => {
      this.lineChartData.labels = [];
      this.isJourneySummaryLoading = false;
      this.cdr.detectChanges();
    })
  }
  lineChartDataStorage: any = [];

  prepareTrendSummary(trendSummary: any, initData: boolean = false) {
    let labels: any[] = [];
    let nps: any[] = [];
    let trendData: any = {};

    if (initData) {
      this.lineChartDataStorage = Helpers.deepClone(trendSummary);
      if (!_.isEmpty(trendSummary) && Object.keys(trendSummary).length > 24) {
        this.lineChartType = 'yearly';
      } else {
        this.lineChartType = 'monthly';
      }
    }
    _.each(trendSummary, (data: any, key: any) => {
      const obj = _.find(data, (item: any) => item[this.journeyFieldId] == this.selectedLineChartjourney);
      if (obj && obj.date) {
        const dateLabel = (this.lineChartType == 'monthly') ? moment(obj.date).format('MMM YYYY') : moment(obj.date).format('YYYY');
        if (!trendData[dateLabel] || !_.isEmpty(trendData[dateLabel])) {
          trendData[dateLabel] = obj;
        } else {
          trendData[dateLabel].total_responses += obj.total_responses;
          trendData[dateLabel].promoters += obj.promoters;
          trendData[dateLabel].detractors += obj.detractors;
        }
      }

    })
    _.each(trendData, (data: any, key: any) => {
      if (data && data?.total_responses > 0) {
        const npsValue = this.getNPS(data.total_responses, data.promoters, data.detractors);
        labels.push(key);
        nps.push(npsValue);
      }
    });
    this.updateLineChartData(labels, nps);
  }

  lineChartType: string = 'monthly';
  changeLineChartType(type: string) {
    this.lineChartType = type;
    this.isJourneySummaryLoading = true;
    this.prepareTrendSummary(_.cloneDeep(this.lineChartDataStorage), false);
    this.isJourneySummaryLoading = false;
    this.cdr.detectChanges();
  }

  changeLineChartView(event: any) {
    this.selectedLineChartjourney = event?.field_id || event?.name;
    this.isJourneySummaryLoading = true;
    this.getJourneyTrendSummary(event?.field_id || event?.name);
    this.isJourneySummaryLoading = false;
    this.cdr.detectChanges();
  }

  updateLineChartData(labels: any[], nps: any[]) {
    // this.lineChartData = {
    //   labels: labels,
    //   data: nps,
    //   xText: `Journey (${this.selectedLineChartjourney})`,
    //   yText: 'NPS',
    //   yTextDisplayName: 'Repeat Customer NPS®',
    // };
    this.lineChartConfig.data = {
      labels: [...labels],
      datasets: [
        {
          data: [...nps],
          borderColor: '#6C63FF',
          borderWidth: 3,
          pointBorderWidth: 0,
          label: 'Response Date',
          pointRadius: 0,
          pointBorderColor: '#6C63FF',
          pointBackgroundColor: '#6C63FF'
        }
      ]
    };
  }

  changeBarChartType(type: string) {
    this.isRatingDistributionLoading = true;
    this.barChartType = type;
    this.barChart.showPercentage = type == 'percent';
    let labels: any[] = [];
    let promoters: any[] = [];
    let passives: any[] = [];
    let detractors: any[] = [];
    let nps: any[] = [];

    let mapData: any = {};
    _.each(this.barChartDataStorage, (value: any) => {
      const key = value.journey_id || value.journey_name;
      mapData[key] = value;
    });
    _.each(this.journeyConfig.configs, (config: any) => {
      const key = config.id || config.name;
      if (this.selectedJourneyIds.includes(key) || this.selectedBarChartjourney == "All") {
        let value = mapData[key];
        if (value && value?.total_responses > 0) {
          labels.push(config.name);
          promoters.push(this.computeValue(value.promoter, value.total_responses, type == 'percent'));
          passives.push(this.computeValue(value.passive, value.total_responses, type == 'percent'));
          detractors.push(this.computeValue(value.detractor, value.total_responses, type == 'percent'));
          nps.push(this.getNPS(value.total_responses, value.promoter, value.detractor));

        }
      }

    });

    this.updateBarChartData(labels, promoters, passives, detractors);
    this.isRatingDistributionLoading = false;
    this.cdr.detectChanges();
  }

  getDetailedSummary(groupBy?: string) {
    let params: any = this.getQueryParams();
    if (groupBy) {
      params.group_by = groupBy;
      params.limit = 100;
    }
    if (groupBy == 'user') {
      params.limit = 10;
    } else {
      params.limit = 100;
    }
    params.page_number = 1;
    this._relationshipService.getRelationshipDetailedSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
      if (_.get(res, 'data.code') == 0 && _.get(res, 'data.summary') && !_.isEmpty(res?.data?.summary)) {
        this.prepareDetailedSummary(res.data.summary, groupBy);
      } else {
        if (groupBy == 'user') {
          this.isUserSummaryLoading = false;
        } else {
          this.isProjectSummaryLoading = false;
        }
        this.cdr.detectChanges();
      }
    }, (error: any) => {
      if (groupBy == 'user') {
        this.isUserSummaryLoading = false;
      } else {
        this.isProjectSummaryLoading = false;
      }
      this.cdr.detectChanges();
    })
  }

  prepareDetailedSummary(data: any, groupBy?: string) {
    if (groupBy == 'user') {
      this.customers = data;
      this.customers = _.sortBy(this.customers, 'total_responses').reverse();
      this.customers = this.customers.map((customer: any) => {
        return {
          ...customer,
          id: customer.user_id,
          nps: this.getNPS(customer.total_responses, customer.promoter, customer.detractor)
        }
      });
      this.isUserSummaryLoading = false;
    } else {
      this.projects = data;
      this.projects = _.sortBy(this.projects, 'total_responses').reverse();
      this.projects = this.projects.map((project: any) => {
        return {
          ...project,
          name: this.brandDetailsMap[project.brand_id]?.name || project?.brand_id,
          id: project?.brand_id,
          nps: this.getNPS(project?.total_responses, project?.promoter, project?.detractor)
        }
      });
      this.isProjectSummaryLoading = false;
    }
    this.cdr.detectChanges();
  }



  getNPS(total: number, promoters: number, detractors: number) {
    if (total > 0) {
      return (((promoters / total) * 100) - ((detractors / total) * 100)).toFixed(0);
    }
    return 'NA';
  }

  getNPSValue(nps: number) {
    return nps.toFixed(0);
  }





  getQueryParams() {
    let query: any = {
      account_id: this.accountId,
      from: moment().subtract(2, 'year').format('YYYYMMDD'),
      to: moment().format('YYYYMMDD')
    }
    if (this._relationshipService.unique_field_id) {
      query.unique_field_id = this._relationshipService.unique_field_id
    }
    if (this._relationshipService.unique_field_type) {
      query.unique_field_type = this._relationshipService.unique_field_type
    }
    if (this._relationshipService.min_doc_count) {
      query.min_doc_count = this._relationshipService.min_doc_count
    }
    return query
  }

  openCustomerJourney(customer: any) {
    this.selectedCustomer = customer;
    this.cdr.detectChanges();
  }

  closeCustomerJourney() {
    this.selectedCustomer = null;
    this.cdr.detectChanges();
  }

  /**
   * Returns the height in px for a bar segment in the stacked bar chart.
   * @param stage The stage number (1-based)
   * @param type The segment type ('promoters' | 'passives' | 'detractors')
   */
  getBarHeight(stage: number, type: 'promoters' | 'passives' | 'detractors'): string {
    const totalHeight = 100; // px
    const data = this.barData[stage - 1];
    return data ? `${(data[type] * totalHeight) / 100}px` : '0px';
  }

  isDropdownOpen: boolean = false;
  selectedField: any = '';
  rawSelectedName: string = '';
  selectedJourneyIds: any[] = ['all'];
  selectedIdclone: any[] = [];
  onButtonClick(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    if(this.isDropdownOpen) {
      this.selectedIdclone = _.cloneDeep(this.selectedJourneyIds);
    } else {
      this.selectedJourneyIds = _.cloneDeep(this.selectedIdclone);
      this.selectedIdclone = [];
    }
  }

  onOptionClick(item: any): void {
    if(item?.field_id == 'all') {
      if(this.selectedJourneyIds.includes('all')) {
        this.selectedJourneyIds = [];

      } else {
        this.selectedJourneyIds.push('all');
        _.each(this.barChartDropdown.options, (option: any) => {
          if(option.field_id != 'all') {
            this.selectedJourneyIds.push(option.field_id);
          }
        });
      }
    } else {
      if(this.selectedJourneyIds.includes('all')) {
        this.selectedJourneyIds = _.filter(this.selectedJourneyIds, (id: any) => id != 'all');
      }
      if (this.selectedJourneyIds.includes(item?.field_id)) {
        this.selectedJourneyIds = this.selectedJourneyIds.filter(id => id !== item?.field_id);
      } else {
        this.selectedJourneyIds.push(item?.field_id);
      }
    }
   
    this.cdr.detectChanges();
  }

  onDoneClick(){
    this.isDropdownOpen = false;

    if (this.selectedJourneyIds.length === 0 || this.selectedJourneyIds.includes('all')) {
      this.selectedBarChartjourney = 'All';
    } else {
      const names = this.barChartDropdown.options
        .filter((opt: any) => this.selectedJourneyIds.includes(opt.field_id) && opt.field_id !== 'all')
        .map((opt: any) => opt.name || opt.text);
      this.selectedBarChartjourney = names.length ? names.join(', ') : 'All';
    }

    this.isRatingDistributionLoading = true;
    this.changeBarChartType(this.barChartType);
    this.isRatingDistributionLoading = false;
    this.cdr.detectChanges();
  }

  tooltipText: string = '';
  tooltipPosition = { top: 0, left: 0 };
  tooltipVisible: boolean = false;

  showTooltip(event: MouseEvent, option: any) {
    this.tooltipText = option.name ? option.name : option.text;
    this.tooltipPosition = {
      top: event.clientY - 300,
      left: event.clientX - 130
    };
    this.tooltipVisible = true;
  }

  hideTooltip() {
    this.tooltipVisible = false;
  }
  getPrefix(prefix) {
    if (prefix != undefined || prefix != '') {
      return prefix.toLowerCase()
    }
  }
  showTitle(option) {
    return option.name ? option.name : option.text;
  }



} 